import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

export type MainButtonState = {
  text: string;
  visible: boolean;
  enabled: boolean;
  loading: boolean;
  onClick: () => void;
} | null;

export type BackButtonState = {
  visible: boolean;
  onClick: () => void;
} | null;

type WebChromeCtx = {
  main: MainButtonState;
  back: BackButtonState;
  setMain: (s: MainButtonState) => void;
  setBack: (s: BackButtonState) => void;
};

const Ctx = createContext<WebChromeCtx | null>(null);

/**
 * Хранит дескрипторы главной кнопки и кнопки «Назад», которые в Mini App
 * рисует Telegram нативно, а в вебе рендерит компонент WebChrome.
 * setMain/setBack — стабильные сеттеры useState, поэтому хуки могут безопасно
 * держать их в зависимостях эффекта без циклов перерисовки.
 */
export function WebChromeProvider({ children }: { children: ReactNode }) {
  const [main, setMain] = useState<MainButtonState>(null);
  const [back, setBack] = useState<BackButtonState>(null);
  const value = useMemo<WebChromeCtx>(
    () => ({ main, back, setMain, setBack }),
    [main, back],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useWebChrome(): WebChromeCtx | null {
  return useContext(Ctx);
}
